import { createElement } from 'react';
import {
  Users,
  Calendar,
  BookOpen,
  ReceiptText,
  Settings,
  LayoutDashboard,
  Building2,
  FileText,
  GraduationCap,
  Bus,
  LucideIcon,
  MessageSquare,
  Bell,
} from 'lucide-react';
import { BASE_PERMISSIONS } from './role';

export interface NavItemConfig {
  label: string;
  baseRoute: string;
  icon: LucideIcon;
  requiredPermissions: string[];
  adminOnly?: boolean;
}

// Shared navigation configuration - single source of truth
// Array order determines both navbar display order and redirection priority
export const baseNavItems: NavItemConfig[] = [
  {
    label: 'Dashboard',
    baseRoute: 'dashboard',
    icon: LayoutDashboard,
    requiredPermissions: [],
    adminOnly: true,
  },
  {
    label: 'Students',
    baseRoute: 'student-management',
    icon: Users,
    requiredPermissions: [
      BASE_PERMISSIONS.STUDENTS.CREATE,
      BASE_PERMISSIONS.STUDENTS.READ,
      BASE_PERMISSIONS.STUDENTS.UPDATE,
      BASE_PERMISSIONS.STUDENTS.DELETE,
    ],
  },
  {
    label: 'Grades',
    baseRoute: 'grades',
    icon: GraduationCap,
    requiredPermissions: [
      BASE_PERMISSIONS.GRADES.READ,
      BASE_PERMISSIONS.GRADES.CREATE,
      BASE_PERMISSIONS.GRADES.UPDATE,
      BASE_PERMISSIONS.GRADES.DELETE,
    ],
  },
  {
    label: 'Team',
    baseRoute: 'team',
    icon: Building2,
    requiredPermissions: [
      BASE_PERMISSIONS.STAFF.CREATE,
      BASE_PERMISSIONS.STAFF.READ,
      BASE_PERMISSIONS.STAFF.UPDATE,
      BASE_PERMISSIONS.STAFF.DELETE,
    ],
  },
  {
    label: 'Transportation',
    baseRoute: 'transportation',
    icon: Bus,
    requiredPermissions: [
      BASE_PERMISSIONS.TRANSPORTATION.CREATE,
      BASE_PERMISSIONS.TRANSPORTATION.READ,
      BASE_PERMISSIONS.TRANSPORTATION.UPDATE,
      BASE_PERMISSIONS.TRANSPORTATION.DELETE,
    ],
  },
  //DEV CHECK: need to verify these changes for exam module
  {
    label: 'Assessments',
    baseRoute: 'assessment',
    icon: BookOpen,
    requiredPermissions: [],
    adminOnly: true,
  },
  {
    label: 'Fees',
    baseRoute: 'fees/receipts',
    icon: ReceiptText,
    requiredPermissions: [
      BASE_PERMISSIONS.FEES.CREATE,
      BASE_PERMISSIONS.FEES.READ,
      BASE_PERMISSIONS.FEES.UPDATE,
      BASE_PERMISSIONS.FEES.DELETE,
    ],
  },
  {
    label: 'Reports',
    baseRoute: 'reports',
    icon: FileText,
    requiredPermissions: [BASE_PERMISSIONS.REPORTS.MANAGE],
  },
  {
    label: 'Notices',
    baseRoute: 'notices',
    icon: Bell,
    requiredPermissions: [BASE_PERMISSIONS.NOTICES.READ],
  },
  {
    label: 'Feedback',
    baseRoute: 'suggestions-complaints',
    icon: MessageSquare,
    requiredPermissions: [BASE_PERMISSIONS.FEEDBACKS.READ],
  },
  {
    label: 'Settings',
    baseRoute: 'settings',
    icon: Settings,
    requiredPermissions: [
      BASE_PERMISSIONS.SETTINGS.READ,
      BASE_PERMISSIONS.SETTINGS.MANAGE,
    ],
  },
];
